const SAFE_ABSOLUTE_PROTOCOLS = ['http:', 'https:'];

export const isSafeAssetUrl = (url: string | null | undefined): url is string => {
  if (!url || typeof url !== 'string') {
    return false;
  }

  const trimmed = url.trim();

  if (trimmed === '') {
    return false;
  }

  if (trimmed.startsWith('//')) {
    return false;
  }

  if (trimmed.startsWith('/')) {
    return true;
  }

  try {
    const parsed = new URL(
      trimmed,
      typeof window !== 'undefined' ? window.location.origin : 'https://www.coursera.org'
    );
    return SAFE_ABSOLUTE_PROTOCOLS.includes(parsed.protocol);
  } catch {
    return false;
  }
};

export default isSafeAssetUrl;
